import {
  fetchCertainPaymentMethodEpic,
  PAYMENT_METHOD_FEATURE_KEY,
  paymentMethodReducer,
} from '@cashier/cashier-data-access';
import { createFeature } from '@cashier/cashier-shared';

import { PaymentProcessing as PaymentProcessingV2 } from './lib/v2';
import { PaymentProcessing as PaymentProcessingV3 } from './lib/v3';

export const PaymentProcessingFeature = createFeature({
  component: {
    PaymentProcessingV2,
    PaymentProcessingV3,
  },

  hook: {},

  store: {
    epics: [fetchCertainPaymentMethodEpic],

    middlewares: [],

    reducerMap: {
      [PAYMENT_METHOD_FEATURE_KEY]: paymentMethodReducer,
    },
  },
});
